import { Component, OnInit } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { Router } from '@angular/router';
import { OrganizationsService } from '../services/organizationService/organization.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import * as jwt_decode from 'jwt-decode';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { RoleLevel } from '../services/organizationService/organization.enum';

export interface PeriodicElement {
  organizationName: string;
  organizationType: string;
  database: string;
  representative: string;
  email: string;
  phone: string;
  lastLogin:string;
  totalSpent:string;
  status:string;
  action:string;
}

export interface Row {
  organizationName: string,
  organizationType: string,
  database: string,
  representativePerson:string,
  email:string,
  phone:string,
  offices?:Row[]
}

export const ROWS: Row[] = [
  {
    organizationName: "Standford Medical Center",
    organizationType: "Health Care",
    database: "Dedicated",
    representativePerson: "Matt Mcalpin",
    email:"matt@gmail.com",
    phone:"9876743825",
  },
  {
    organizationName: "Green Care",
    organizationType: "Surgery Center",
    database: "Shared",
    representativePerson: "Matt Mcalpin",
    email:"matt@gmail.com",
    phone:"9876743825",
    offices: [
      {
        organizationName: "GK",
        organizationType: "Legal",
        database: "Shared",
        representativePerson: "Matt Mcalpin",
        email:"matt@gmail.com",
        phone:"9876743825",
      },
      {
        organizationName: "WTO",
        organizationType: "Education",
        database: "Dedicated",
        representativePerson: "Matt Mcalpin",
        email:"matt@gmail.com",
        phone:"9876743825",
      },
    ]
  },
  {
    organizationName: "European Central",
    organizationType: "Hospital",
    database: "Shared",
    representativePerson: "Matt Mcalpin",
    email:"matt@gmail.com",
    phone:"9876743825",
  },
  {
    organizationName: "World Trade",
    organizationType: "Doctor",
    database: "Dedicated",
    representativePerson: "Matt Mcalpin",
    email:"matt@gmail.com",
    phone:"9876743825",
    offices: [
      {
        organizationName: "ILO",
        organizationType: "Real Estate",
        database: "Shared",
        representativePerson: "Matt Mcalpin",
        email:"matt@gmail.com",
        phone:"9876743825",
      },
      {
        organizationName: "ICRC",
        organizationType: "Legal",
        database: "Dedicated",
        representativePerson: "Matt Mcalpin",
        email:"matt@gmail.com",
        phone:"9876743825",
      },
    ]
  },
];

@Component({
  selector: 'app-organization-list',
  templateUrl: './organization-list.component.html',
  styleUrls: ['./organization-list.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', overflow:'hidden'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})


export class OrganizationListComponent implements OnInit {
  expanded: {[key: string]: boolean} = {};
  rows = ROWS;
    
  addListing:boolean = false;
  selectiontype:string=""
  organizationData:any=[]=[];
  organizationResponseHolder: any;
  organizationList: any[] = [];
  value = 'Clear me';
  indexExpanded: number;
  currentUser: any;
  totalCount: number = 0;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    organizationID:0,
    officeID:0
  };
  pageIndex: any;
  pageSize: any;
  organizationListShow:boolean=false;
  organizationId:number=0;
  databaseId:string="";
  rolesAsssign: any[] = [];
  OrgCreateoption:boolean=false;
  Officecreateoption:boolean=false;
  officeAdmin:boolean=false;
  superAdmin:boolean=false;
  permissionAsssign: any[] = [];
  OfficeIDList: any=[];
  myOfficeID: any;

  constructor(private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private statusConst: StatusConstant,private loaderService: LoaderService,
    private router: Router, private organizationService: OrganizationsService, private constant: Constants,
    private _dataSharingService: DataSharingService,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = Number(sessionStorage.getItem('organizationID'));
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }


  ngOnInit(): void {
    this.permissionAsssign = JSON.parse(sessionStorage.getItem("menuModules"));  
    this.permissionAsssign =this.permissionAsssign.filter((x) => x.mainModuleName == 'Admin' && x.isAssign==true);
    if(this.permissionAsssign.length == 0){
      this.router.navigate(['unauthorised']);
      return;
    }
    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));   
    if(this.rolesAsssign.length > 0){
      var role=[];
       // roleLevel:1 (Super admin), roleLevel:2 (Organization Admin), roleLevel:3 (Office Admin),
       // roleLevel:11 (User)
      
     role= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OfficeAdmin);
     if(role.length > 0){
      this.myOfficeID=this.myOfficeID;
      this.officeAdmin=true;
      this.OrgCreateoption=false;
      this.Officecreateoption = false;
     } 

      role= this.rolesAsssign.filter((m) => m.roleLevel ==  RoleLevel.OrganizationAdmin);
      if(role.length > 0){
       this.myOfficeID=0;
       this.OrgCreateoption=false;
       this.Officecreateoption = true;
       this.officeAdmin=false;
     }
     
     role= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin);
       if(role.length > 0){
        this.myOfficeID=0;
        this.OrgCreateoption=true;
        this.Officecreateoption = true;
        this.organizationId=0;
        this.getOraganizationList(this.pageModelData);
        return;
      }
    }
    this.getOraganizationList(this.pageModelData);    
  }

  getOraganizationList(pageData: any) {
    this.loaderService.show();    
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.organizationID = Number(this.organizationId);
    this.pageModelData.officeID = this.myOfficeID;
    this.pageIndex = pageData.pageIndex;
    this.pageSize = pageData.pageSize;
    this.organizationService.getOffices(this.pageModelData).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.organizationResponseHolder = response;
        if (this.organizationResponseHolder.status == this.statusConst.statusSuccess) {          
          this.organizationList=this.organizationResponseHolder.data.organizations;
          if(this.organizationList.length>0){
            this.organizationListShow=false;
          }else{
            this.organizationListShow=true;
          }
          this.totalCount = this.organizationResponseHolder.data.totalCount;
          this.pageModelData.pageIndex = this.organizationResponseHolder.data.pageIndex;
          this.pageIndex = this.organizationResponseHolder.data.pageIndex;
          this.pageSize = pageData.pageSize;
          this.loaderService.hide();
        }else{
          this.organizationList = [];
          this.loaderService.hide();
        }
      }else{
        this.organizationList =[];
        this.loaderService.hide(); 
      }
    });
  }

  Orgdetails(data){
    sessionStorage.setItem('orgdetail', JSON.stringify(data));   
    this.router.navigate(['organization/orgdetail']);
  }

  getClose(message) {
   // this.getOraganizationList(this.pageModelData);
    this.addListing = message;
  }
    
  getCloseAfterSave(message) {
     this.getOraganizationList(this.pageModelData);
     this.addListing = message;
   }

  addNew(type,data) {
    this.selectiontype=type;
    if(this.selectiontype=="Existing"){
      this.organizationData=data;
    }else{
      this.organizationData=[];
    }        
    this.addListing = !this.addListing;
  } 
  

  isRowClickable(rowIndex: number) {
   // this.indexExpanded = rowIndex;
    return this.organizationList[rowIndex].offices && this.organizationList[rowIndex].offices.length > 0;
  }
}
